import _classPrivateFieldInitSpec from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import _classPrivateFieldSet from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import { log } from './log';
var _instance = /*#__PURE__*/new WeakMap();
var _componentInternalInstance = /*#__PURE__*/new WeakMap();
var _ref = /*#__PURE__*/new WeakMap();
class CommonDialog {
  constructor() {
    _classPrivateFieldInitSpec(this, _instance, null);
    _classPrivateFieldInitSpec(this, _componentInternalInstance, null);
    _classPrivateFieldInitSpec(this, _ref, '');
  }
  init(ref) {
    _classPrivateFieldSet(_instance, this, ref);
  }
  initByComponentInstance(component, ref) {
    _classPrivateFieldSet(_componentInternalInstance, this, component);
    _classPrivateFieldSet(_ref, this, ref);
  }
  open(data) {
    if (_classPrivateFieldGet(_instance, this)) {
      _classPrivateFieldGet(_instance, this).value.open(data);
    } else if (_classPrivateFieldGet(_componentInternalInstance, this)?.refs && _classPrivateFieldGet(_componentInternalInstance, this).refs[_classPrivateFieldGet(_ref, this)]) {
      _classPrivateFieldGet(_componentInternalInstance, this).refs[_classPrivateFieldGet(_ref, this)]?.open(data);
    } else {
      log('CommonDialog', '未获取到CommonDialog实例', 'error');
    }
  }
  close() {
    if (_classPrivateFieldGet(_instance, this)) {
      _classPrivateFieldGet(_instance, this).value.close();
    } else if (_classPrivateFieldGet(_componentInternalInstance, this)?.refs && _classPrivateFieldGet(_componentInternalInstance, this).refs[_classPrivateFieldGet(_ref, this)]) {
      _classPrivateFieldGet(_componentInternalInstance, this).refs[_classPrivateFieldGet(_ref, this)]?.close();
    } else {
      log('CommonDialog', '未获取到CommonDialog实例', 'error');
    }
  }
}
export default CommonDialog;